
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/engine.io-client/index.js
// module id = ../../../../engine.io-client/index.js
// module chunks = 4